import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center bg-gmoaa-surface text-gmoaa-text-muted">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
